/*

TEXT TO ASCII LINK
https://patorjk.com/software/taag/#p=display&f=Varsity&t=LINK%20TREE


  _____     _____  ____  _____  ___  ____    _________  _______     ________  ________  
 |_   _|   |_   _||_   \|_   _||_  ||_  _|  |  _   _  ||_   __ \   |_   __  ||_   __  | 
   | |       | |    |   \ | |    | |_/ /    |_/ | | \_|  | |__) |    | |_ \_|  | |_ \_| 
   | |   _   | |    | |\ \| |    |  __'.        | |      |  __ /     |  _| _   |  _| _  
  _| |__/ | _| |_  _| |_\   |_  _| |  \ \_     _| |_    _| |  \ \_  _| |__/ | _| |__/ | 
 |________||_____||_____|\____||____||____|   |_____|  |____| |___||________||________| 
                                                                                        
*/

$(document).ready(function () {
// Team Accordion
  // Hide all accordion content on page load
  $('.accordion-content').hide();

  // Toggle the clicked section without hiding others
  $('.accordion-header').on('click', function () {
    const $content = $(this).next('.accordion-content');
    $content.slideToggle(); // Toggle the clicked section
  });
//

  
  // Ensure Section 1 is visible on load and Section 2 is hidden
  $('#linkTree_section1').show();
  $('#linkTree_section2, #linkTree_section3').hide();
  $('#linkTreeButton').addClass('active');

    
  // Handle Link Tree button click
  $('#linkTreeButton').on('click', function (e) {
    e.preventDefault();
  
    // Fade in Section 1 and fade out Section 2
    $('#linkTree_section2, #linkTree_section3').fadeOut(400, function () {
      $('#linkTree_section1').fadeIn(400);
    });
  
    // Update active class
    $('.toggle-button').removeClass('active');
    $(this).addClass('active');
  });
  
  // Handle Payments button click
  $('#paymentsButton').on('click', function (e) {
    e.preventDefault();
  
    // Fade in Section 2 and fade out Section 1
    $('#linkTree_section1, #linkTree_section3').fadeOut(400, function () {
      $('#linkTree_section2').fadeIn(400);
    });
  
    // Update active class
    $('.toggle-button').removeClass('active');
    $(this).addClass('active');
  });
  
  // Handle newsletter button click
  $('#newsletter-signup').on('click', function (e) {
    e.preventDefault();
  
    // Fade out Sections 1 & 2, then fade in Section 3
    $('#linkTree_section1, #linkTree_section2').fadeOut(400, function () {
      $('#linkTree_section3').fadeIn(400);
    });
  
    // Update active class
    $('.toggle-button').removeClass('active');
    $(this).addClass('active');
  });

  // Open the modal
  $('#newsletter-open').on('click', function () {
    $('#newsletter-modal').fadeIn();
  });



  
  // Close the modal
$('#newsletter-modal-close').on('click', function () {
  // Show the password modal with animation
  $('#password-check-modal').css('display', 'block');

  // Animate from above into view
  setTimeout(() => {
    $('#password-check-modal').css('top', '40px');
  }, 10);
});

$('#admin-password-submit').on('click', function () {
  const password = $('#admin-password-input').val();

  // Clear the input regardless of success or failure
  $('#admin-password-input').val('');

  if (password.length === 4 && password === '1234') {
    // Correct password
    $('#password-error-message').hide();
    $('#password-check-modal').css('top', '-100px');
    setTimeout(() => {
      $('#password-check-modal').css('display', 'none');
    }, 400);

    $('#newsletter-modal').fadeOut();
  } else {
    // Show error message briefly, then hide modal
    $('#password-error-message').fadeIn();

    setTimeout(() => {
      $('#password-error-message').fadeOut();
      $('#password-check-modal').css('top', '-100px');
      setTimeout(() => {
        $('#password-check-modal').css('display', 'none');
      }, 400);
    }, 1000);
  }
});
  
$('#admin-password-submit').on('click', function () {
  const password = $('#admin-password-input').val();

  // Clear the input regardless of success or failure
  $('#admin-password-input').val('');

  if (password.length === 4 && password === '1234') {
    // Correct password
    $('#password-error-message').hide();
    $('#password-check-modal').css('top', '-100px');
    setTimeout(() => {
      $('#password-check-modal').css('display', 'none');
    }, 400);

    $('#newsletter-modal').fadeOut();
  } else {
    // Show error message briefly, then hide modal
    $('#password-error-message').fadeIn();

    setTimeout(() => {
      $('#password-error-message').fadeOut();
      $('#password-check-modal').css('top', '-100px');
      setTimeout(() => {
        $('#password-check-modal').css('display', 'none');
      }, 400);
    }, 1000);
  }
});


  
  $('.crypto-list a').on('click', function (e) {
    e.preventDefault(); // Prevent default link behavior

    const url = $(this).data('url'); // Get the URL from data attribute

    // Copy the URL to the clipboard
    navigator.clipboard.writeText(url).then(() => {
      // Show notification
      $('#notification')
        .stop(true, true)
        .text('Address Copied')
        .fadeIn(200)
        .delay(2000)
        .fadeOut(500);
    }).catch(err => {
      console.error('Could not copy text: ', err);
    });
  });


const hash = window.location.hash;
console.log("Current hash window.location.hash:", window.location.hash);
console.log("Current hash just hash:", hash);


if (hash === "#newsletter-linkTree-form") {
  $('#linkTree_section1, #linkTree_section2').hide();
  $('#linkTree_section3').show();
  $('.toggle-button').removeClass('active');
  $('#newsletter-signup').addClass('active');
  $('#Newsletter-success-linktree').show();
  
  setTimeout(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, 50);
  
  setTimeout(() => {
    window.scrollTo({ top: 80, behavior: 'smooth' });
  }, 50);
  
  setTimeout(() => {
    $('#Newsletter-success-linktree').fadeOut(600);
  }, 4000);
}

else if (hash === "#newsletter-linkTree-admin-form") {
  $('#linkTree_section1, #linkTree_section2').hide();
  $('#linkTree_section3').show();
  $('.toggle-button').removeClass('active');
  $('#newsletter-signup').addClass('active');
  $('#newsletter-modal').show();
  $('#newsletter-modal .modal-content')[0]?.scrollIntoView({ behavior: 'smooth' });
  $('#Newsletter-success-admin').show();

  setTimeout(() => {
    $('#Newsletter-success-admin').fadeOut(600);
  }, 4000);
}
  
  
});


/*
  ______   _____     _____  ______   ________  _______     
.' ____ \ |_   _|   |_   _||_   _ `.|_   __  ||_   __ \    
| (___ \_|  | |       | |    | | `. \ | |_ \_|  | |__) |   
 _.____`.   | |   _   | |    | |  | | |  _| _   |  __ /    
| \____) | _| |__/ | _| |_  _| |_.' /_| |__/ | _| |  \ \_  
 \______.'|________||_____||______.'|________||____| |___| */


$(document).ready(function() {
  
/*  #   BANNER SLIDERS - SHOP, ROADMAP */ 
  var slider = $('.slider');
  var sliderItem = $('.slider-item');
  var sliderNavItem = $('.slider-nav-item');
  var arrowPrev = $('#arrow-prev');
  var arrowNext = $('#arrow-next');
  var currentIndex = 0;

  function navigateTo(index) {
    if (index < 0 || index >= sliderItem.length) return;
    
    sliderItem.removeClass('active');
    sliderItem.eq(index).addClass('active');
    slider.css('transform', 'translateX(-' + (index * 33.33) + '%)');

    sliderNavItem.removeClass('active');
    sliderNavItem.eq(index).addClass('active');

    currentIndex = index;
  }

  sliderNavItem.click(function() {navigateTo($(this).index());});

  arrowPrev.click(function() {navigateTo(currentIndex - 1);});

  arrowNext.click(function() {navigateTo(currentIndex + 1);});
  
  // Slide automatically every 15 seconds
  setInterval(function() {navigateTo((currentIndex + 1) % sliderItem.length);}, 15000);

});
                                                           

